<!--
 * @Author: wxy
 * @LastEditors: chenming
 * @Description: 手机号
-->
<template>
  <div>
    <div
      v-if="magnify && showMagnify"
      class="lc-phone-number__magnify"
    >
      <span class="lc-phone-number__magnify__text">{{ phoneNumberModel }}</span>
    </div>
    <div class="lc-phone-number__wrap">
      <div class="lc-phone-number__content">
        <div v-if="globalization" class="lc-phone-number__content__area">
          <el-select v-model="phoneArea">
            <el-option
              v-for="item in areaOpts"
              :key="item.value"
              :label="item.label.split(' ')[1]"
              :value="item.value"
            >
              {{ item.label }}
            </el-option>
          </el-select>
        </div>
        <div :class="{ 'lc-phone-number__content__globalization' : globalization}">
          <el-input
            v-model="phoneNumberModel"
            :placeholder="placeholder"
            v-bind="$attrs"
            @blur="handleBlur"
            @focus="handleFocus"
          />
        </div>
      </div>
    </div>
    <p v-if="phoneNumberModel && validMessage" class="lc-phone-number__error-message">
      {{ errorNotice }}
    </p>
  </div>
</template>
<script>
import { PhoneNumberUtil } from "google-libphonenumber";
const phoneUtil = PhoneNumberUtil.getInstance();
const defaultArea = '+86'

export default {
  name: 'LcPhoneNumber',
  props: {
    value: {
      type: String,
      default: ''
    },
    //是否国际化
    globalization: {
      type: Boolean,
      default: false
    },
    //是否放大展示
    magnify: {
      type: Boolean,
      default: false
    },
    //输入提示语
    placeholder: {
      type: String,
      default: ''
    },
    // 国际区号列表
    areaOpts: {
      type: Array,
      default: () => [
        {
          label: '中国 +86',
          value: '+86'
        }, {
          label: '美国 +1',
          value: '+1'
        }, {
          label: '日本 +81',
          value: '+81'
        }
      ]
    },
    errorNotice: {
      type: String,
      default: '手机号格式错误'
    },
  },
  data() {
    return {
      formValue: '',
      validMessage: false,
      showMagnify: false,
    };
  },
  computed: {
    phoneNumberModel: {
      get() {
        let str = this.formValue.replace(/\s*/g,"")
        for (let index = 0; index < this.areaOpts.length; index++) {
          let value = '\\' + this.areaOpts[index].value;
          let regExp = new RegExp(value);
          let match = str.match(regExp)
          if(match && match.index == 0 && this.globalization) {
            str = str.replace(regExp, '')
          }
        }
        str = this.handleFormatValue(str);
        return str;
      },
      set(val) {
        if(val[0] == '+' || !this.globalization) {
          this.formValue = val;
        } else if(Number(val.replace(/\s*/g,""))) {
          this.formValue = this.phoneArea + val.replace(/\s*/g,"");
        } else{
          this.formValue = this.phoneArea
        }
      }
    },
    phoneArea: {
      get() {
        let phoneArea = defaultArea;
        for (let index = 0; index < this.areaOpts.length; index++) {
          let value = '\\' + this.areaOpts[index].value;
          let regExp = new RegExp(value);
          let match = this.formValue.match(regExp)
          if(match && match.index == 0) {
            phoneArea = match[0]
            return phoneArea
          }
        }
        return phoneArea;
      },
      set(val) {
        this.formValue = val + this.phoneNumberModel.replace(/\s*/g,"");
      }
    }
  },
  watch: {
    phoneNumberModel() {
      this.checkValidPhone();
    },
    phoneArea() {
      this.checkValidPhone();
    },
    formValue(val) {
      this.$emit('input', val.replace(/\s*/g,""))
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const val = this.value
      if (val[0] == '+') {
        const phoneData = phoneUtil.parse(val)
        this.phoneArea = '+' + phoneData.values_['1']
        this.phoneNumberModel = String(phoneData.values_['2'])
      } else {
        this.phoneNumberModel = val
      }
    },
    checkValidPhone() {
      try {
        if (this.phoneNumberModel) {
          let phoneNumber = this.phoneNumberModel.replace(/\s*/g,"")
          let area = this.phoneArea.replace(/\+/g,"")
          let number = phoneUtil.parseAndKeepRawInput(phoneNumber, phoneUtil.getRegionCodeForCountryCode(area));
          this.validMessage = !phoneUtil.isValidNumber(number);
        }
      } catch (error) {
        this.validMessage = true;
      }
    },
    handleFormatValue(val) {
      let str = val.replace(/\s*/g,"");
      let formatValue = ''
      if(Number(str) || str == '+') {
        let arr = [];
        let first = str.slice(0, 3);
        if(first) {
          arr.push(first);
          let second = str.slice(3, 7);
          if(second) {
            arr.push(second);
            let last = str.slice(7, 11);
            if(last) {
              arr.push(last);
            }
          }
        }
        formatValue =  arr.join(' ');
      } else {
        formatValue = '';
      }
      return formatValue
    },
    handleBlur (e) {
      this.showMagnify = false;
    },
    handleFocus (e) {
      this.showMagnify = true;
    },
  },
};
</script>
<style lang="scss">
.lc-phone-number{
  position: relative;
  &__magnify {
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    padding: 10px;
    margin-bottom: 5px;
    border-radius: 4px;
    word-break: break-word;
    background: #f6f6f6;
    color: #ff984c;
    font-size: 24px;
    line-height: 1;
  }
  &__error-message{
    position: absolute;
    top: 100%;
    left: 0;
    padding-top: 4px;
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
  }

}
.lc-phone-number__wrap{
  width: var(--width, 240px);
}
.lc-phone-number__content {
  position: relative;
  display: flex;
  .el-select{
    .el-input__inner{
        width: 100%;
      }
  }
  &__area{
    width: 85px;
    .el-select{
      width: 85px;
    }
  }
  &__globalization{
    margin-left: 5px;
    flex: 1;
    .el-input, .el-input__inner{
      width: 100% !important;
    }
  }
}
</style>
